import React, { Component }     from 'react';
import Lottie                   from 'react-lottie';
import GreenTick                from 'assets/lotties/green-tick';
import PreregistrationService   from 'services/preregistration.service';
import AuthService              from 'services/auth.service';

export class ConfirmationCodeInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isStopped: true,
      isPaused: false,
      confirmationCode: Array(6).fill('')
    };
  }

  showStatus(status) {
    var greenTick   = document.querySelector('.confirmation-code-placeholder[name="green-tick"]');
    var numberBoxes = document.querySelector('.confirmation-code-placeholder[name="code-boxes"]');
    var errorMsg    = document.querySelector('#error-message');

    if (status === 'green-tick') {
      greenTick.style.display   = 'flex';
      numberBoxes.style.display = 'none';
      this.setState({ isStopped: false });
    } else if (status === 'error-boxes') {
      greenTick.style.display   = 'none';
      errorMsg.style.display    = 'block';
      numberBoxes.style.display = 'block';
      numberBoxes.classList.add('error-danger');
      this.setState({ isStopped: true });
    } else {
      numberBoxes.classList.remove('error-danger');
      errorMsg.style.display    = 'none';
    }
  }

  handleOnFocus(index) {
    this.setStateConfirmationCode(index, '');
  }

  handleOnChange(index, value) {
    let check;

    if (value === '') {
      this.setStateConfirmationCode(index, value);
      return;
    } else if (!value.match(/\d/)) {
      return;
    } else {
      const updatedValues = this.setStateConfirmationCode(index, value);
      check = updatedValues.join('');
    }

    if (index < 5) {
      var querySelector = '.confirmation-code-boxes:nth-child(' + (index + 2) + ')';
      var nextBox       = document.querySelector(querySelector);
      setTimeout(() => nextBox.focus(), 100); // Need to set timeout, otherwise clicking on multiple keys at once will cause it to jump multiple spaces.
    } else if (check.length === 6) {
      const parameters = {
        "visit": {
          "visit_no": check
        }
      };

      PreregistrationService.confirmAttendance(this.props.id, parameters).then(
        (data) => {
          if (data.status === 'success') {
            this.showStatus('green-tick');
          }
        },
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace('/eb/login');
          }

          if (error.response.data.error === 'visit_no mismatched') {
            this.showStatus('error-boxes');
          }
        }
      );
    }
  }

  setStateConfirmationCode(index, value) {
    var values        = this.state.confirmationCode.slice();
    values[index]     = value;
    this.setState({ 'confirmationCode': values });
    return values;
  }

  render() {
    const defaultOptions = {
      loop: false,
      autoplay: false,
      animationData: GreenTick,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }
    };

    const whiteBoxes = this.state.confirmationCode.map((value, index) => {
      return (
        <input key={ index } type="text" value={ value } className="confirmation-code-boxes" maxLength={ 1 } onChange={(e) => this.handleOnChange(index, e.target.value)} onFocus={(e) => this.handleOnFocus(index, e.target) } />
      )
    });

    return (
      <div>
        <div className="my-12 confirmation-code-placeholder" name="code-boxes">
          <div className="d-flex align-items-center justify-content-center">
            { whiteBoxes }
          </div>

          <p id="error-message" className="text-danger text-center font-size-4 mt-5">The entered number is inaccurate. Please re-enter.</p>
        </div>

        <div className="my-8 confirmation-code-placeholder justify-content-center" name="green-tick">
          <div className="w-em-12">
            <Lottie options={ defaultOptions } isStopped={ this.state.isStopped } isPaused={ this.state.isPaused } isClickToPauseDisabled={ true } />
          </div>
        </div>
      </div>
    );
  }
}